import { StyleSheet } from 'aphrodite';
import { destructive, titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		width: 480,
		maxWidth: '100%',
		padding: '0 32px 28px',
		boxSizing: 'border-box',
	},
	closeButtonContainer: {
		textAlign: 'right',
		padding: '12px 12px 0 0',
	},
	title: {
		color: titles,
		fontSize: 20,
		fontWeight: 600,
		marginTop: 4,
		marginBottom: 16,
	},
	titleDestructive: {
		color: destructive,
	},
	modeSelector: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
		marginBottom: 20,
		padding: '12px 14px',
		border: '1px solid #E5E5E5',
		borderRadius: 6,
	},
	modeOption: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 10,
		cursor: 'pointer',
		fontSize: 13,
		color: titles,
	},
	modeOptionRadio: {
		marginTop: 2,
	},
	modeOptionLabel: {
		fontWeight: 600,
	},
	modeOptionDescription: {
		fontSize: 12,
		color: '#767676',
		marginTop: 2,
		marginBottom: 5,
	},
	body: {
		color: titles,
		fontSize: 14,
		lineHeight: 1.5,
		marginBottom: 18,
	},
	warningBanner: {
		backgroundColor: '#FDEAEB',
		color: destructive,
		padding: '12px 14px',
		borderRadius: 6,
		marginBottom: 16,
		fontSize: 13,
		lineHeight: 1.5,
	},
	count: {
		fontWeight: 600,
	},
	label: {
		display: 'block',
		fontSize: 13,
		color: titles,
		marginBottom: 5,
	},
	inputWrap: {
		marginBottom: 20,
	},
	datePickerContainer: {
		background: white,
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 12,
		marginTop: 12,
	},
});
